import dayjs from 'dayjs';

type Props = {
  dateStr: string | null;
  type?: 'logogram' | 'writeAll';
};

export const RevxDateWeek = ({ dateStr, type = 'writeAll' }: Props) => {
  const week = [
    {
      logogram: 'Mon.',
      writeAll: 'Monday',
    },
    {
      logogram: 'Tue.',
      writeAll: 'Tuesday',
    },
    {
      logogram: 'Wed.',
      writeAll: 'Wednesday',
    },
    {
      logogram: 'Thu.',
      writeAll: 'Thursday',
    },
    {
      logogram: 'Fri.',
      writeAll: 'Friday',
    },
    {
      logogram: 'Sat.',
      writeAll: 'Saturday',
    },
    {
      logogram: 'Sun.',
      writeAll: 'Sunday',
    },
  ];
  return <>{dateStr ? week[dayjs(dateStr).day()][type] : null}</>;
};
